// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_JeKvc {
  width: 400px;
  height: 100%;
}

.pad_eWcem {
  padding: var(--size-padLarge, 10px);
}

.header_qi0_T {
  position: relative;
}

.contentArea_n0qNn {
  background: #f3f5f6;
}

.close_pDpD2 {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.successImage_Ibnmt {
  margin: 20px auto;
  display: block;
}

.buttonContainer_YB1GZ {
  width: 100%;
  background-color: white;
  border-radius: 6px;
  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;
  padding: 0 10px;
}

.buttonContainer_YB1GZ > * {
  border-bottom: 1px solid var(--color-base200) !important;
}

.buttonContainer_YB1GZ > *:last-child {
  border-bottom: none !important;
}

.loadingArea_hGzRM {
  height: 100%;
  width: 100%;
}

.ordinal_sUZbM {
  height: 22px;
}

.locatorError_FpEsK {
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/views/AssetPairingValidation/Pair.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".content {\n  width: 400px;\n  height: 100%;\n}\n\n.pad {\n  padding: var(--size-padLarge, 10px);\n}\n\n.header {\n  position: relative;\n}\n\n.contentArea {\n  background: #f3f5f6;\n}\n\n.close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.successImage {\n  margin: 20px auto;\n  display: block;\n}\n\n.buttonContainer {\n  width: 100%;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;\n  padding: 0 10px;\n}\n\n.buttonContainer > * {\n  border-bottom: 1px solid var(--color-base200) !important;\n}\n\n.buttonContainer > *:last-child {\n  border-bottom: none !important;\n}\n\n.loadingArea {\n  height: 100%;\n  width: 100%;\n}\n\n.ordinal {\n  height: 22px;\n}\n\n.locatorError {\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_JeKvc`,
	"pad": `pad_eWcem`,
	"header": `header_qi0_T`,
	"contentArea": `contentArea_n0qNn`,
	"close": `close_pDpD2`,
	"successImage": `successImage_Ibnmt`,
	"buttonContainer": `buttonContainer_YB1GZ`,
	"loadingArea": `loadingArea_hGzRM`,
	"ordinal": `ordinal_sUZbM`,
	"locatorError": `locatorError_FpEsK`
};
export default ___CSS_LOADER_EXPORT___;
